<template lang="pug">
  .menuBtn
    v-menu.theMenu(open-on-hover :bottom="fromMenu" :offset-y="fromMenu" :right="fromDrawer" :offset-x="fromDrawer")
      template(v-slot:activator='{ on }')
        v-btn.noCursor(v-on="on",text :class="{'v-btn--active': isActive}") Events
          
      v-list.theList(color="#3C8C40",dark )
        v-list-item(v-for='(item, index) in items' :key='index' :to="item.path" @click="updateRootPage")
          v-list-item-title {{ item.title }}
</template>
<script>
export default {
  props: ['fromDrawer', 'fromMenu'],
  data: () => ({
    items: [
      { title: 'Our Calendar', path: '/events/our-calendar' },
      { title: 'News', path: '/events/news' }
    ]
  }),
  methods: {
    updateRootPage() {
      this.$store.commit('setRoot', 'events');
    }
  },
  computed: {
    isActive() {
      let theRoot = this.$store.getters.getRoot;
      console.log('TCL: isActive -> theRoot', theRoot);
      return theRoot == 'events' ? true : false;
    }
  }
};
</script>
